import { useContext, useLayoutEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { uiAppInit } from "Store/Actions";
import { selectIsAuthenticated } from "Store/Selectors/Authentication";
import { selectActualTheme } from "Store/Selectors/UI";
import { useAuthenticationPreflight } from "./Generic/Authentication";
import { ConfigurationContext } from "./Generic/Configuration";
import { IUseAppProps } from "./IUseAppProps";

export function useApp(): IUseAppProps {
  const { preflightAuthentication } = useAuthenticationPreflight();
  const dispatch = useDispatch();
  const config = useContext(ConfigurationContext);
  const themeType = useSelector(selectActualTheme);
  const theme = useMemo(() => config.getThemeByType(themeType), [config, themeType]);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    preflightAuthentication().then(() => dispatch(uiAppInit()));
  }, [dispatch, isAuthenticated, preflightAuthentication]);

  return {
    isAuthenticated,
    theme
  };
}
